import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfLink from '@elem/ui/ef-link';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionJ');
    const { locale } = getLocal();

    return (
        <div className={styles.TheComp} id="section-SectionJ">
            <EfSpec />
            <div className="ef-container">
                <div className="SectionJ-in">
                    <div className="SectionJ-icon">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1721388973197/cc1.png" />
                    </div>
                    <div className="SectionJ-desc">{t('desc')}</div>
                    <div className="SectionJ-btn-box">
                        <EfLink
                            className="thePage-btn SectionJ-btn"
                            href={`https://www.ecoflow.com/${locale}/x-core-3`}
                            dataLayer={[
                                {
                                    event: 'uaEvent',
                                    event_name: 'activity_preview',
                                    button_name: t('btn'),
                                },
                            ]}
                        >
                            {t('btn')}
                        </EfLink>
                    </div>
                </div>
            </div>
        </div>
    );
}
